import classNames from 'classnames'
import React from 'react'
import './index.css'
import View from 'components/View'

export default function SidebarFooter ({
  shouldShowAovUnlock,
  shouldShowAovLock,
  ...rest
}) {
  return (
    <View
      className={
        classNames({
          'sidebar-footer': true,
          'sidebar-footer_with-aov-lock': shouldShowAovLock,
          'sidebar-footer_with-aov-unlock': shouldShowAovUnlock
        })
      }
      {...rest}
    />
  )
}
